__turbopack_context__.v({
  "banner": "PlasmicPricingTopSection-module__8dHgsW__banner",
  "col": "PlasmicPricingTopSection-module__8dHgsW__col",
  "img": "PlasmicPricingTopSection-module__8dHgsW__img",
  "sectionHeader": "PlasmicPricingTopSection-module__8dHgsW__sectionHeader",
  "subtitle": "PlasmicPricingTopSection-module__8dHgsW__subtitle",
  "title": "PlasmicPricingTopSection-module__8dHgsW__title",
  "top": "PlasmicPricingTopSection-module__8dHgsW__top",
  "top2": "PlasmicPricingTopSection-module__8dHgsW__top2",
  "wrapper": "PlasmicPricingTopSection-module__8dHgsW__wrapper",
});
